<template>
  <div class="phone-number">{{ formattedPhone }}</div>
</template>

<script>

function formatPhoneNumber (phoneNumberString) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, match[2], '-', match[3], '-', match[4]].join('')
  }
  return null
}

export default {
  name: 'PhoneNumber',
  props: ['phone'],
  data () {
    return {
      formattedPhone: formatPhoneNumber(this.phone)
    }
  }
}
</script>

<style scoped>

</style>
